import { SavedAddresses } from "@/views/Settings/Location.tsx";

/**
 * The home-and-work address chooser, inline in a card.
 *
 * Renders the same `SavedAddresses` the Location settings screen does, rather
 * than a second pair of address fields that would drift from it. It takes no
 * props, reads the addresses itself, and commits each row as it's saved — so a
 * user who fills in home and abandons the card keeps home.
 *
 * No memory is written alongside the address, unlike the onboarding step. The
 * address already reaches the agent as `location.homeAddress` in
 * `settings.LIST`, and a second copy in the memory store would be one no other
 * edit path updates — every later change, here or in settings, would leave it
 * asserting an address the user has moved out of.
 */
export const LocationsPickerBody = () => (
  // The omni card's treatment rather than the settings page's: on the canvas the
  // group sits on a card-coloured modal, so it needs an edge of its own to read
  // as a table at all.
  <SavedAddresses className="rounded-md border border-input bg-transparent" />
);
